//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    import index_b from '@/assets/images/技能培训选中.png'
    import index_p from '@/assets/images/技能培训.png'
    import info_b from '@/assets/images/信息公开选中.png'
    import info_p from '@/assets/images/信息公开.png'
    import entre_b from '@/assets/images/创业培训选中.png'
    import entre_p from '@/assets/images/创业培训.png'
    import emp_b from '@/assets/images/精准就业选中.png'
    import emp_p from '@/assets/images/精准就业.png'
    import per_b from '@/assets/images/个人中心选中.png'
    import per_p from '@/assets/images/个人中心.png'

    export default {
        data() {
            return {
            }
        },
        created(){
        },
        mounted(){

        },
        computed: {

        },

        methods: {
            gotoAddress(path){
                this.$router.push(path)
            }
        },

        filters: {
            indexImg : function (value) {
                if (value) {
                    return index_b
                } else {
                    return index_p
                }
            },
            infoImg : function (value) {
                if (value !== -1 ) {
                    return info_b
                } else {
                    return info_p
                }
            },
            entreImg : function (value) {
                if (value !== -1 ) {
                    return entre_b
                } else {
                    return entre_p
                }
            },
            empImg : function (value) {
                if (value !== -1 ) {
                    return emp_b
                } else {
                    return emp_p
                }
            },
            perImg : function (value) {
                if (value !== -1 ) {
                    return per_b
                } else {
                    return per_p
                }
            }

        }
    }




// WEBPACK FOOTER //
// ./src/components/footer/footer.vue